module.exports = __webpack_public_path__ + "static/6-fe9b50c2bb3c63a0cb58fcee29c89cd6.png";